jQuery(document).ready(function ($) {

    function addToCartVariable() {
        jQuery('.product-type-variable .single_add_to_cart_button').on('click', function (Event) {
            Event.preventDefault();

            let $form = $(this).closest('form');
            let product_id = $form.find('input[name="product_id"]').val();
            let variation_id = $form.find('input[name="variation_id"]').val();
            let quantity = $form.find('input.qty').val() || 1;

            // Collect the variation attributes
            let variation = {};
            $form.find('select[name^=attribute], input[name^=attribute]').each(function () {
                let attribute_name = $(this).attr('name');
                let attribute_value = $(this).val();
                variation[attribute_name] = attribute_value;
            });

            if (!variation_id || !product_id) {
                console.error('Product ID or Variation ID is missing.');
                return;
            }

            // Perform an AJAX request
            jQuery.ajax({
                type: 'POST',
                dataType: 'json',
                url: ajaxAuthObject.ajax_url,
                data: {
                    action: 'realm_add_to_cart_variable',
                    variation_id: variation_id,
                    product_id: product_id,
                    quantity: quantity,
                    variation: variation,
                },
                success: function (response) {
                    if (response.success) {
                        $(document.body).trigger('added_to_cart');
                        $(document.body).trigger('wc_fragment_refresh');
                        $(document.body).trigger('update_checkout');
                        $(document.body).trigger('updated_cart_totals');
                    }
                },
                error: function error(errorThrown) {
                    console.error('AJAX Error:', errorThrown);
                },
            });
        });
    }

    addToCartVariable();

    // Update Checkout Quantity
    function updateQuantityCheckout() {
        let checkQuantityCheckout = document.querySelector('.woocommerce-checkout .realm-product__quantity');
        if (checkQuantityCheckout) {
            $(document).on('click', '.plus, .minus', function () {
                // Get the quantity element
                var qty = $(this).closest('.woocommerce-checkout .realm-product__quantity').find('input.qty');
                var val = parseInt(qty.val());
                var max = parseInt(qty.attr('max'));
                var min = parseInt(qty.attr('min'));
                var step = parseInt(qty.attr('step'));
                let new_val = 1;

                // Change the value if plus or minus
                if ($(this).is('.plus')) {
                    if (max && (max <= val)) {
                        new_val = max;
                    } else {
                        new_val = val + step;
                    }
                } else {
                    if (min && (min >= val)) {
                        new_val = min;
                    } else if (val > 1) {
                        new_val = val - step;
                    }
                }

                qty.val(new_val);
                // Set the new quantity value
                qty.attr("value", new_val);
                // Trigger the on change function
                qty.trigger('change');
                //console.log(new_val);

                // Set the added_to_cart buttons change function
                var $thisbutton = qty;
                // Get the input name attribute hash // $cart_item_key
                var item_hash = qty.attr('name').replace(/cart\[([\w]+)\]\[qty\]/g, "$1");

                jQuery.ajax({
                    type: 'POST',
                    url: ajaxAuthObject.ajax_url,
                    data: {
                        action: 'realm_update_quantity_checkout',
                        hash: item_hash,
                        quantity: new_val,
                    },
                    dataType: 'json',
                    success: function (response) {
                        if (response.fragments) {
                            $.each(response.fragments, function (key, value) {
                                $(key).replaceWith(value);
                            });
                        }

                        jQuery(document.body).trigger('update_checkout'); // Qliro needs this
                    },
                });
            });
        }
    }

    updateQuantityCheckout();

    function resetForms() {
        $('form').each(function () {
            $(this).trigger('reset');
            $(this).find('.success, .error').removeClass('success error');
            $(this).find('.error-message').hide();
        });
    }

    // Login form
    function loginFormSubmit() {
        $('#login-form').submit(function (Event) {
            Event.preventDefault();

            var form = $(this);
            var submitButton = form.find('input[type="submit"]');
            submitButton.attr('disabled', 'disabled');

            var email = form.find('#login-email').val();
            var password = form.find('#login-password').val();
            var remember = $('#remember').is(':checked');

            if (!email || !password) {
                form.find('#login-email').addClass('error');
                form.find('#login-password').addClass('error');
                form.find('.error-message').text('Epost och lösenord är obligatoriskt.').show();
                submitButton.removeAttr('disabled');
                return;
            }

            $.ajax({
                type: 'POST',
                url: ajaxAuthObject.ajax_url,
                data: {
                    action: 'login_action',
                    login_email: email,
                    login_password: password,
                    remember: remember
                },
                dataType: 'json',

                success: function (response) {
                    submitButton.prop('disabled', false);
                    if (response.success) {
                        var successMessage = `
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path fill="#f04c4d" d="M25.009 18.883a.5.5 0 0 1-.376-.17 5.503 5.503 0 0 0-4.133-1.872c-1.17 0-2.333.384-3.273 1.081a.499.499 0 1 1-.595-.803 6.548 6.548 0 0 1 3.869-1.277c1.87 0 3.65.806 4.885 2.211a.501.501 0 0 1-.377.83z"/>
					<path fill="#499ed7" d="M13.397 14.461a.5.5 0 0 1-.45-.718 5.515 5.515 0 0 0 .553-2.401c0-.964-.255-1.916-.736-2.75a.5.5 0 1 1 .866-.5 6.508 6.508 0 0 1 .219 6.088.503.503 0 0 1-.452.281z"/>
					<path fill="#ffcc5c" d="m4.818 25.849 6.405-12.227a1 1 0 0 1 1.593-.243l5.147 5.147a1 1 0 0 1-.243 1.593L5.493 26.524a.5.5 0 0 1-.675-.675z"/>
					<path fill="#f7b546" d="m17.963 18.526-5.147-5.147a1 1 0 0 0-1.593.243l-.056.108 1.873 1.873a3 3 0 0 1-.729 4.779l-6.378 3.341-1.114 2.126a.5.5 0 0 0 .675.675l12.227-6.405a1 1 0 0 0 .242-1.593z"/>
					<path fill="#f47423" d="m7.93 25.247 1.253-.656-3.185-.995-.471.9zm-1.15-3.144 4.48 1.4 1.253-.656-5.261-1.644zm1.253-2.393 6.556 2.049 1.253-.656-7.337-2.293zm1.254-2.392 8.573 2.679a.973.973 0 0 0 .361-.935l-8.462-2.644-.472.9zm1.253-2.392 5.56 1.737-1.524-1.523-3.565-1.114z"/>
					<path fill="#ed5d25" d="m18.22 19.062-4.318-1.349c.001.34-.051.676-.162.997l4.12 1.287c.14-.112.24-.252.303-.405l.014-.035a.987.987 0 0 0 .043-.495zm-5.707 3.785-3.075-.961-1.253.656 3.075.961.292-.153zm.526-7.244c.043.043.069.093.108.138l2.952.923-1.524-1.524-2.909-.909 1.373 1.372zm-7.512 8.893 2.403.751 1.253-.656-3.075-.961-.176.093zm6.783-4.114-.795.417 3.075.961 1.253-.656-3.15-.984c-.125.09-.242.188-.383.262z"/>
					<path fill="#92ca62" d="M8 12.842a1.502 1.502 0 0 1-1.117-2.5 1.494 1.494 0 0 1 0-2A1.502 1.502 0 0 1 8 5.842a.5.5 0 0 1 0 1 .5.5 0 0 0 0 1 .5.5 0 0 1 0 1 .5.5 0 0 0 0 1 .5.5 0 0 1 0 1 .5.5 0 0 0 0 1 .5.5 0 0 1 0 1z"/>
					<path fill="#71bc58" d="M8.033 8.835a.493.493 0 0 0 .434-.328.496.496 0 0 0-.434.328zm.434-2.328a.496.496 0 0 0-.434.328.493.493 0 0 0 .434-.328zM7 11c0-.384.145-.734.383-1a1.494 1.494 0 0 1 0-2 1.494 1.494 0 0 1 .043-2.043 1.501 1.501 0 0 0-.543 2.385 1.493 1.493 0 0 0 0 2A1.502 1.502 0 0 0 8 12.842a.495.495 0 0 0 .469-.345A1.5 1.5 0 0 1 7 11z"/>
					<path fill="#71bc58" d="M8.033 10.835a.493.493 0 0 0 .433-.328.495.495 0 0 0-.433.328z"/>
					<path fill="#ae89be" d="M21.732 13.901c-.384 0-.768-.146-1.061-.438a.5.5 0 0 1 .707-.708.5.5 0 0 0 .707-.708.498.498 0 0 1 0-.708.5.5 0 0 1 .707 0 .5.5 0 0 0 .707-.707.498.498 0 0 1 0-.708.5.5 0 0 1 .707 0 .514.514 0 0 0 .707 0 .495.495 0 0 0 .146-.354.495.495 0 0 0-.146-.353.5.5 0 0 1 .707-.708c.283.283.439.66.439 1.061a1.499 1.499 0 0 1-1.417 1.498 1.496 1.496 0 0 1-1.415 1.415c-.02.356-.165.707-.437.978-.289.294-.674.44-1.058.44z"/>
					<path fill="#9676b5" d="M22.25 11.342a.494.494 0 0 0 .625.055c-.027-.018-.058-.03-.082-.055a.494.494 0 0 0-.625-.055c.027.018.058.031.082.055zm1.414-1.414a.506.506 0 0 0 .625.053c-.028-.018-.058-.029-.082-.053a.494.494 0 0 0-.625-.055c.027.018.058.031.082.055zm-2.828 2.828a.494.494 0 0 0 .625.055c-.027-.018-.058-.03-.082-.055a.495.495 0 0 0-.625-.054c.027.018.058.03.082.054z"/>
					<path fill="#9676b5" d="M25.621 8.513a.495.495 0 0 0-.625-.054c.027.018.058.03.082.054.283.283.439.66.439 1.061a1.499 1.499 0 0 1-1.417 1.498 1.496 1.496 0 0 1-1.415 1.415c-.02.356-.165.707-.437.978-.222.222-.501.332-.789.385.091.017.179.053.271.053a1.497 1.497 0 0 0 1.498-1.416 1.498 1.498 0 0 0 1.415-1.415 1.498 1.498 0 0 0 1.417-1.498 1.487 1.487 0 0 0-.439-1.061z"/>
					<path fill="#499ed7" d="M16.175 25.802a.5.5 0 0 1-.43-.245 1.498 1.498 0 0 1 1.58-2.237c.107-.34.335-.644.665-.839.329-.196.701-.25 1.055-.181.11-.353.344-.649.665-.839a1.485 1.485 0 0 1 1.137-.163c.388.099.715.344.919.688a.5.5 0 1 1-.862.51.498.498 0 0 0-.914.132.495.495 0 0 0 .055.378.502.502 0 0 1-.86.511.502.502 0 0 0-.686-.175.502.502 0 0 0-.175.686.5.5 0 0 1-.862.51.49.49 0 0 0-.306-.229.5.5 0 0 0-.553.739.499.499 0 0 1-.428.754z"/>
					<path fill="#2b8ec6" d="M16.31 25.558a1.498 1.498 0 0 1 .524-2.056c.152-.091.318-.149.488-.181a1.477 1.477 0 0 0-1.053.181 1.49 1.49 0 0 0-.688.919 1.49 1.49 0 0 0 .164 1.137.502.502 0 0 0 .685.175c.013-.007.019-.02.031-.028a.516.516 0 0 1-.151-.147zm1.719-1.021a.49.49 0 0 0-.306-.229.494.494 0 0 0-.379.055c-.01.006-.016.016-.025.022.057.04.108.09.144.152a.501.501 0 0 0 .686.175c.01-.006.013-.017.023-.023a.497.497 0 0 1-.143-.152zm-.138-1.216c.107-.34.335-.644.665-.839.329-.196.701-.25 1.055-.181a1.483 1.483 0 0 1 1.143-1.017 1.483 1.483 0 0 0-1.708 1.017 1.483 1.483 0 0 0-1.055.181c-.33.196-.557.498-.664.838.184-.035.374-.038.564.001zm1.86.196a.502.502 0 0 0-.686-.175c-.01.006-.016.016-.025.023.057.04.107.089.145.153a.5.5 0 0 0 .685.174c.01-.006.013-.017.022-.023a.502.502 0 0 1-.141-.152zm1.719-1.02a.498.498 0 0 0-.685-.174c-.01.006-.016.016-.025.022.057.04.108.09.144.152a.501.501 0 0 0 .686.175c.01-.006.015-.016.025-.022a.494.494 0 0 1-.145-.153z"/>
					<circle cx="15" cy="5.342" r="1" fill="#ae89be"/>
					<circle cx="23" cy="5.342" r="1" fill="#499ed7"/>
					<circle cx="27" cy="15.342" r="1" fill="#ffcc5c"/>
					<circle cx="4" cy="19.342" r="1" fill="#f04c4d"/>
					<path fill="#9676b5" d="M15 4.342a.996.996 0 0 0-.375.076.997.997 0 0 1 0 1.848.996.996 0 0 0 .375.076 1 1 0 0 0 0-2z"/>
					<path fill="#2b8ec6" d="M23 4.342a.996.996 0 0 0-.375.076.997.997 0 0 1 0 1.848.996.996 0 0 0 .375.076 1 1 0 0 0 0-2z"/>
					<path fill="#f7b546" d="M27 14.342a.996.996 0 0 0-.375.076.997.997 0 0 1 0 1.848.996.996 0 0 0 .375.076 1 1 0 0 0 0-2z"/>
					<path fill="#e13340" d="M4 18.342a.996.996 0 0 0-.375.076.997.997 0 0 1 0 1.848.996.996 0 0 0 .375.076 1 1 0 0 0 0-2z"/>
					<circle cx="24" cy="25.342" r="1" fill="#f04c4d"/>
					<path fill="#e13340" d="M24 24.342a.996.996 0 0 0-.375.076.997.997 0 0 1 0 1.848.996.996 0 0 0 .375.076 1 1 0 0 0 0-2z"/>
					<path fill="#f04c4d" d="M26.421 21.88a.5.5 0 0 1-.493-.421 5.325 5.325 0 0 0-.245-.956.5.5 0 1 1 .944-.332 6.698 6.698 0 0 1 .289 1.13.501.501 0 0 1-.495.579z"/>
					<path fill="#499ed7" d="M12.016 7.383a.498.498 0 0 1-.333-.127 5.847 5.847 0 0 0-.427-.346.5.5 0 0 1 .594-.804 6.864 6.864 0 0 1 .499.406.5.5 0 0 1-.333.871z"/>
					<path fill="#92ca62" d="M16.794 14.858a.5.5 0 0 1-.363-.845 7.465 7.465 0 0 0 2.068-5.172c0-1.133-.263-2.27-.759-3.287a.5.5 0 1 1 .898-.438 8.537 8.537 0 0 1 .86 3.726 8.46 8.46 0 0 1-2.344 5.861.49.49 0 0 1-.36.155z"/><circle cx="8" cy="14.342" r=".5" fill="#92ca62"/>
					</svg>
					<p class="success">Kul att se dig igen!</p>
					`;
                        form.hide();
                        $('#forgot-password-link').hide();
                        $("#login-message").html(successMessage).show();
                        setTimeout(function () {
                            history.go(0);
                        }, 1500);
                        resetForms();
                    } else {
                        form.find('#login-email').addClass('success');
                        form.find('.error-message').hide();
                        if (response.data.email) {
                            form.find('#login-email').removeClass('success').addClass('error');
                            form.find('.email-field .error-message').text(response.data.email).show();
                        }
                        if (response.data.password) {
                            form.find('#login-password').addClass('error');
                            form.find('.password-field .error-message').text(response.data.password).show();
                        }
                        submitButton.removeAttr('disabled');
                    }
                },
                error: function (error) {
                    console.log(error);
                    submitButton.removeAttr('disabled');
                }
            });
        });
    }

    loginFormSubmit();

    // Registration form
    function registrationFormSubmit() {
        $('#registration-form').on('submit', function (Event) {
            Event.preventDefault();
            var form = $(this);
            var submitButton = form.find('input[type="submit"]');
            submitButton.attr('disabled', 'disabled');
            var display_name = form.find('#register-username').val();
            var email = form.find('#register-email').val();
            var password = form.find('#register-password').val();
            var confirmPassword = form.find('#register-confirm-password').val();

            $.ajax({
                type: 'POST',
                url: ajaxAuthObject.ajax_url,
                data: {
                    action: 'register_action',
                    register_username: display_name,
                    register_email: email,
                    register_password: password,
                    register_confirm_password: confirmPassword
                },
                dataType: 'json',
                success: function (response) {
                    submitButton.removeAttr('disabled');
                    if (response.success) {
                        var successIcon = `
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
					<circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"></circle>
					<polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "></polyline>
					</svg>`;
                        var successText = '<p>Välkommen ' + display_name + '</p><p>Tack för att du skapade ditt konto, du kan nu logga in med ' + email + '.</p>';
                        form.hide();
                        $("#register-message").append(successIcon, successText);
                        resetForms();
                    } else {
                        form.find('#register-username').addClass('success');
                        form.find('#register-email').addClass('success');
                        form.find('.error-message').hide();
                        if (response.data.register_username) {
                            form.find('#register-username').removeClass('success').addClass('error');
                            form.find('.register-username-field .error-message').text(response.data.register_username).show();
                        }
                        if (response.data.register_email) {
                            form.find('#register-email').removeClass('success').addClass('error');
                            form.find('.register-email-field .error-message').text(response.data.register_email).show();
                        }
                        if (password !== confirmPassword) {
                            form.find('#register-password').removeClass('success').addClass('error');
                            form.find('#register-confirm-password').removeClass('success').addClass('error');
                            form.find('.confirm-password-field .error-message').text(response.data.register_confirm_password).show();
                            submitButton.removeAttr('disabled');
                        }
                    }
                },
                error: function (error) {
                    console.log(error);
                    submitButton.removeAttr('disabled');
                }
            });
        });
    }

    registrationFormSubmit();

    // Password reset
    function passwordResetSubmit() {
        $('#forgot-password-form').submit(function (Event) {
            Event.preventDefault();
            var form = $(this),
                submitButton = form.find('input[type="submit"]');
            submitButton.attr('disabled', 'disabled');
            var email = form.find('#forgot-password-email').val();

            $.ajax({
                type: 'POST',
                url: ajaxAuthObject.ajax_url,
                data: {
                    action: 'verification_code_action',
                    forgot_password_email: email,
                },
                dataType: 'json',
                success: function (response) {
                    submitButton.removeAttr('disabled');
                    if (response.success) {
                        var successIcon = `
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
						<circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"></circle>
						<polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "></polyline>
						</svg>`;
                        var successText = '<p>Ett verifikationsmail med engångskod har skickats till ' + email + ', vänligen titta din inkorg.</p>';
                        form.hide();
                        $('#login-link').hide();
                        $('#forgot-password-message').empty().append(successIcon, successText);
                        $('#verification-email').val(email);
                        $('#forgot-password-message').delay(2400).fadeOut();
                        $('#verification-form').delay(2800).fadeIn();
                        resetForms();
                    } else {
                        form.find('#forgot-password-email').removeClass('success').addClass('error');
                        form.find('.error-message').text(response.data.message).show();
                        if (response.data.email) {
                            form.find('#forgot-password-email').removeClass('error').addClass('success');
                            form.find('.forgot-password-field .error-message').text(response.data.message).hide();
                            $('#forgot-password-message').delay(2400).fadeOut();
                        }
                    }
                },
                error: function (error) {
                    console.log(error);
                    submitButton.removeAttr('disabled');
                }
            });
        });
    }

    passwordResetSubmit();

    // Verification code
    function verificationFormSubmit() {
        $('#verification-form').submit(function (Event) {
            Event.preventDefault();
            var form = $(this),
                submitButton = form.find('input[type="submit"]');
            submitButton.attr('disabled', 'disabled');
            var email = form.find('#verification-email').val();
            var verificationCode = form.find('#verification-code').val();
            var new_password = form.find('#new-password').val();
            var verify_new_password = form.find('#verify-new-password').val();
            var savedVerificationCode = '';

            $.ajax({
                type: 'POST',
                url: ajaxAuthObject.ajax_url,
                data: {
                    action: 'update_password_action',
                    verification_email: email,
                    verification_code: verificationCode,
                    new_password: new_password,
                    verify_new_password: verify_new_password,
                },
                dataType: 'json',
                success: function (response) {
                    var savedVerificationCode = response.data.savedVerificationCode;
                    submitButton.removeAttr('disabled');

                    if (response.success) {
                        var successIcon = `
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
						<circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"></circle>
						<polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "></polyline>
						</svg>`;
                        var successText = '<p>Lösenordet har uppdaterats.</p>';
                        form.hide();
                        $('#verification-success').empty().append(successIcon, successText);
                        $('#verification-success').delay(2400).fadeOut();
                        $('#login-link').delay(2400).fadeOut();
                        $('#login-form').delay(2800).fadeIn();
                        $('#forgot-password-link').delay(2800).fadeIn();
                        resetForms();
                    } else {
                        if (verificationCode === savedVerificationCode) {
                            form.find('#verification-code').addClass('success').removeClass('error');
                            form.find('.verification-field .error-message').hide();
                        } else {
                            form.find('#verification-code').addClass('error').removeClass('success');
                            form.find('.verification-field .error-message').text(response.data.errorVerification).show();
                        }

                        if (new_password === verify_new_password) {
                            form.find('#new-password, #verify-new-password').addClass('success').removeClass('error');
                            form.find('.verification-code-field .error-message').hide();
                        } else {
                            form.find('#new-password, #verify-new-password').addClass('error').removeClass('success');
                            form.find('.verification-code-field .error-message').text(response.data.errorMessage).show();
                        }
                    }
                },
                error: function (error) {
                    submitButton.removeAttr('disabled');
                    console.log(error);
                }
            });
        });
    }

    verificationFormSubmit();

    function forgotPassword() {
        $("#forgot-password-link").click(function () {
            $("#login-form").hide();
            $("#forgot-password-link").hide();
            $("#forgot-password-form").show();
            $("#login-link").show();
        });
        $("#login-link").click(function () {
            $("#login-link").hide();
            $("#forgot-password-link").show();
            $("#forgot-password-form").hide();
            $("#login-form").show();
        });
    }

    forgotPassword();

    // Popular categories
    function loadMorePopularCategories() {
        let page = 1;

        function scrollToTop() {
            $('html, body').animate({
                scrollTop: $('#realm-popular-categories_top').offset().top
            }, 300);
        }

        $('#realm-popular-categories_top .load-more-wrapper .load-more-button').on('click', function () {
            let $loadMoreButton = $(this);
            let $closeButton = $('#realm-popular-categories_top .load-more-wrapper .close-button');

            page++;

            $.ajax({
                type: 'POST',
                url: ajaxPopularObject.ajax_url,
                dataType: 'json',
                data: {
                    action: 'realm_load_more_popular_categories',
                    popular_categories_nonce: ajaxPopularObject.popular_categories_nonce,
                    page: page,
                    post_id: ajaxPopularObject.post_id
                },
                beforeSend: function () {
                    $loadMoreButton.addClass('is-loading');
                },
                success: function (response) {
                    $loadMoreButton.removeClass('is-loading');

                    if (response.success) {
                        $('.realm-popular-categories_grid').append(response.data.html);

                        const totalPages = Math.floor(response.data.total_categories / response.data.categories_per_page);

                        if (page >= totalPages) {
                            $loadMoreButton.hide();
                            $closeButton.show();
                        }
                    }
                },
                error: function (xhr, status, error) {
                    console.log('Error:', status, error);
                }
            });
        });

        $('#realm-popular-categories_top .load-more-wrapper .close-button').on('click', function () {
            $('.realm-popular-categories_grid-item').slice(8).remove();
            $(this).hide();
            $('#realm-popular-categories_top .load-more-wrapper .load-more-button').show();
            page = 1;
            scrollToTop();
        });
    }

    loadMorePopularCategories();

    function loadMoreProductsBlock() {

        jQuery('.load-more-products-block-btn').each(function () {
            var $loadMoreBtn = jQuery(this);
            var postsPerPage = $loadMoreBtn.data('posts-per-page');
            var totalProducts = $loadMoreBtn.data('total-products');
            var maxPages = $loadMoreBtn.data('max-pages');
            var postId = $loadMoreBtn.data('post-id');
            var blockId = $loadMoreBtn.data('block-id');
            var currentPage = 1;
            jQuery('.load-more-products-block-btn.' + blockId).on('click', function (e) {
                e.preventDefault();
                currentPage++;

                jQuery.ajax({
                    type: 'POST',
                    url: ajaxAuthObject.ajax_url,
                    dataType: 'json',
                    data: {
                        'action': 'load_more_products_block',
                        'paged': currentPage,
                        'posts_per_page': postsPerPage,
                        'total_products': totalProducts,
                        'max_pages': maxPages,
                        'post_id': postId,
                    },
                    beforeSend: function () {
                        $loadMoreBtn.addClass('is-loading');
                    },
                    success: function (response) {
                        $loadMoreBtn.removeClass('is-loading');

                        jQuery('.load-more-products-block-container.' + blockId).append(response.data.html);

                        if (currentPage === maxPages) {
                            jQuery('.load-more-products-block-btn-container.' + blockId).remove();
                        }
                    },
                    error: function (xhr, status, error) {
                        var err = JSON.parse(xhr.responseText);
                        console.log(err);
                    }
                });
            });
        });
    }

    loadMoreProductsBlock();

    $('#contactFormSubmit').on('click', function (e) {
        e.preventDefault();
        const $form = $(this).closest('form');
        const formData = $form.serialize();
        const $responseDiv = $form.next('.contact-form-response');

        $.ajax({
            url: ajaxAuthObject.ajax_url,
            type: 'POST',
            data: {
                action: 'submit_contact_form',
                form_data: formData,
            },
            dataType: 'json',
            beforeSend: function () {
                $responseDiv.html('<p class="notification is-info mt-4">Skickar...</p>');
            },
            success: function (response) {
                if (response.success) {
                    $responseDiv.html(`<p class="notification is-success mt-4">${response.data.message}</p>`);
                    $form[0].reset();
                } else {
                    let errorMessages = response.data.errors
                        ? response.data.errors.map(err => `<li>${err}</li>`).join('')
                        : `<p>${response.data.message}</p>`;
                    $responseDiv.html(`<ul class="notification is-danger mt-4">${errorMessages}</ul>`);
                }
            },
            error: function () {
                $responseDiv.html('<p class="notification is-danger">Ett fel inträffade, vänligen försök igen senare.</p>');
            },
        });
    });

    // Signup Form
    $('#signupFormSubmit').on('click', function (e) {
        e.preventDefault();
        const $form = $(this).closest('form');
        const formData = $form.serialize();
        const listID = $form.data('klaviyo-list-id');
        const $responseDiv = $form.next('.signup-form-response');

        $.ajax({
            url: ajaxAuthObject.ajax_url,
            type: 'POST',
            data: {
                action: 'submit_signup_form',
                form_data: formData,
                list_id: listID,
            },
            dataType: 'json',
            beforeSend: function () {
                $responseDiv.html('<p class="notification is-info mt-4">Skickar...</p>');
            },
            success: function (response) {
                if (response.success) {
                    $responseDiv.html(`<p class="notification is-success mt-4">${response.data.message}</p>`);
                    $form[0].reset();
                } else {
                    $responseDiv.html(`<p class="notification is-danger mt-4">${response.data.message}</p>`);
                }
            },
            error: function () {
                $responseDiv.html('<p class="notification is-danger">Ett fel inträffade, vänligen försök igen.</p>');
            },
        });
    });

});